import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GlobalRef } from "../../shared/globals/global-ref";
import { ModelBaseService } from "../../shared/services/model-base.service";
import { UserContextService } from "../../shared/services/user-context.service";
import { IActivityEvent } from "./iactivity-event.model";
import { Observable } from "rxjs";
import { ActivityEventData } from "./activity-event-data.model";
import { IPageableList } from "src/app/shared/interfaces/models/ipageable-list.model";
import { IActivityEventQuery } from "./iactivity-event-query.model";

@Injectable({
  providedIn: "root",
})
export class ActivityEventsService extends ModelBaseService<IActivityEvent> {
  constructor(
    globalContext: GlobalRef,
    protected userContextSvc: UserContextService,
    protected http: HttpClient
  ) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += "ActivityEvents/";
  }

  getUserScoredActivityHistory(
    query: IActivityEventQuery
  ): Observable<IPageableList<ActivityEventData>> {
    let qstr = JSON.stringify(query);
    return this.http.get<IPageableList<ActivityEventData>>(
      this.svcUrl + "GetUserScoredActivityHistory?query=" + qstr
    );
  }
}
